import { render } from "./VirologySectionDetailsEMROATS.vue?vue&type=template&id=63da9bd9&scoped=true"
import script from "./VirologySectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./VirologySectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./VirologySectionDetailsEMROATS.vue?vue&type=style&index=0&id=63da9bd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63da9bd9"],['__file',"src/components/VirologySectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63da9bd9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63da9bd9', __exports__)) {
    api.reload('63da9bd9', __exports__)
  }
  
  module.hot.accept("./VirologySectionDetailsEMROATS.vue?vue&type=template&id=63da9bd9&scoped=true", () => {
    api.rerender('63da9bd9', render)
  })

}


export default __exports__